import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'flux/utils';
import { Link } from 'react-router';

import UserComplianceStore from '../../stores/UserComplianceStore';
import { asCard } from '../Common/Decorators';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import SelectCompliance from '../Compliance/SelectCompliance';
import { addUserCompliance, listUserCompliances, removeUserCompliance } from '../../actions/UserActionCreator';
import Chip from '../Common/Chip';
import LinearProgress from 'material-ui/LinearProgress';

import IconCompliance from 'material-ui/svg-icons/action/assignment-turned-in';


const userCompliance = ({userId, complianceId, name}) => (
    <Chip
        key={complianceId}
        avatar = {(<IconCompliance />)}
        label={name}
        theme="primary"
        onDelete={() => removeUserCompliance(userId, complianceId)}
    />
);

class UserCompliancesCard extends Component {

    componentDidMount() {
        listUserCompliances(this.props.userId);
    }

    render() {
        const { compliances } = this.state;
        const infoLink = '/dashboard/compliances';
        return (
            <div>
                <CardHeader
                    title={<Link to={infoLink} >Compliance</Link>}
                    subtitle='manage user compliance'
                    avatar={<Link to={infoLink} ><IconCompliance /></Link>}
                />
                <CardText className="cent-zero" >
                    <div className="cent-content">
                        <div className="content-left">
                            <SelectCompliance onSelect={(name, id) => addUserCompliance(this.props.userId, id)} />
                        </div>
                        <div className="content-main">
                            <div className="cent-card-chips">
                              {compliances.map(userCompliance)}
                            </div>
                        </div>
                    </div>
                </CardText>
                {this.state.isFetching && <LinearProgress mode="indeterminate"/> }
            </div>
        );
    }
}

UserCompliancesCard.getStores = () => ([UserComplianceStore]);
UserCompliancesCard.calculateState = (prevState, {userId}) => ({
    isFetching: UserComplianceStore.isFetching(),
    compliances: UserComplianceStore.getByUser(userId)
});

UserCompliancesCard.propTypes = {
    userId: PropTypes.number
};

export default asCard(Container.create(UserCompliancesCard, {withProps: true}));
